import Section from 'app/frontend/base/components/Section'
import { useGuild } from 'app/frontend/base/config/context/guild'

const GuildOverview = () => {
  const { guildReference } = useGuild()

  return (
    <Section title={guildReference?.name ?? ''}>
      GuildOverview! {guildReference?.id}
    </Section>
  )
}

export default GuildOverview
